import { render, staticRenderFns } from "./pedidos.vue?vue&type=template&id=1b92ec89&scoped=true"
import script from "./pedidos.vue?vue&type=script&lang=js"
export * from "./pedidos.vue?vue&type=script&lang=js"
import style0 from "./pedidos.vue?vue&type=style&index=0&id=1b92ec89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92ec89",
  null
  
)

export default component.exports